import React from 'react';
import './IndianDestinations.css';

const destinations = [
    {
        name: 'Rajasthan',
        price: '23,500',
        image: 'https://images.unsplash.com/photo-1477587458883-47145ed94245?q=80&w=800&auto=format&fit=crop',
        onclick: () => (window.location.href = '/itinerary/rajasthan')
    },
    {
        name: 'Leh Ladakh',
        price: '12,999',
        image: 'https://images.unsplash.com/photo-1581793745862-99fde7fa73d2?q=80&w=800&auto=format&fit=crop',
        onclick: () => (window.location.href = '/itinerary/leh-ladakh')
    },
    {
        name: 'Punjab',
        price: '12,999',
        image: 'https://images.unsplash.com/photo-1514222134-b57cbb8ce073?auto=format&fit=crop&q=80&w=800',
        onclick: () => (window.location.href = '/itinerary/punjab')
    },
    {
        name: 'Kerala',
        price: '12,999',
        image: 'https://images.unsplash.com/photo-1602216056096-3b40cc0c9944?q=80&w=800&auto=format&fit=crop',
        onclick: () => (window.location.href = '/itinerary/kerala')

    
    },  
    {
        name: 'Maharashtra',
        price: '15,000',
        image: 'https://images.unsplash.com/photo-1566552881560-0be862a7c445?q=80&w=800&auto=format&fit=crop',
        onclick: () => (window.location.href = '/itinerary/maharashtra')
    },
    {
        name: 'Himachal',
        price: '21,000',
        image: 'https://images.unsplash.com/photo-1626621341517-bbf3d9990a23?q=80&w=800&auto=format&fit=crop',
        onclick: () => (window.location.href = '/itinerary/himachal')       
    },
    {
        name: 'Sikkim',
        price: '12,999',
        image: 'https://images.unsplash.com/photo-1626621341517-bbf3d9990a23?q=80&w=800&auto=format&fit=crop',
        onclick: () => (window.location.href = '/itinerary/sikkim')
    },
    {
        name: 'Tamil Nadu',
        price: '14,500',
        image: 'https://images.unsplash.com/photo-1582510003544-4d00b7f74220?auto=format&fit=crop&q=80&w=800',
        onclick: () => (window.location.href = '/itinerary/tamil-nadu')
    },
    {
        name: 'Andaman & Nicobar',
        price: '20,000',
        image: 'https://images.unsplash.com/photo-1544735716-392fe2489ffa?auto=format&fit=crop&q=80&w=800',
        onclick: () => (window.location.href = '/itinerary/andaman-nicobar')
    },
    {
        name: 'Goa',
        price: '15,500',
        image: 'https://images.unsplash.com/photo-1512343879784-a960bf40e7f2?auto=format&fit=crop&q=80&w=800',
        onclick: () => (window.location.href = '/itinerary/goa')
    },
    {
        name: 'Uttar Pradesh',
        price: '11,500',
        image: 'https://www.holidaymonk.com/wp-content/uploads/2024/08/Uttar-Pradesh-Tour-Package.webp',
        onclick: () => (window.location.href = '/itinerary/uttar-pradesh')
    },
    {
        name: 'Delhi',
        price: '16,250',
        image: 'https://images.unsplash.com/photo-1587474260584-136574528ed5?q=80&w=800&auto=format&fit=crop',
        onclick: () => (window.location.href = '/itinerary/delhi')
   
    }
];

const IndianDestinations = () => {
    return (
        <section className="indian-destinations">
            <div className="id-container">
                <div className="id-header">
                    <h2 className="id-title">Indian Holiday Destination</h2>
                    <p className="id-subtitle">
                        Summer has arrived, and you must make urgent planning for an unforgettable summer vacation.<br />
                        India offers travelers with a plethora of thrilling options for a summer vacation with friends, family, and loved ones. Enjoy pleasant weather.
                    </p>
                </div>

                <div className="id-grid">
                    {destinations.map((dest, index) => (
                        <div key={index} className="id-card" onClick={dest.onclick}>
                            <div className="id-image-wrapper">
                                <img src={dest.image} alt={dest.name} loading="lazy" />
                                <div className="id-overlay">
                                    <div className="id-info">
                                        <h3 className="id-name">{dest.name}</h3>
                                        <p className="id-price">From Rs.{dest.price}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default IndianDestinations;
